import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;
    this.state = {
      client_id: '',
      client_secret: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    const { softwares } = this.props;
    const { zenotiData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    console.log('props', this.props);
    this.setState({
      ...((zenotiData.client_id || form.client_id) && {client_id: form.client_id?form.client_id:zenotiData.client_id}),
      ...((zenotiData.client_secret || form.client_secret) && {client_secret: form.client_secret?form.client_secret:zenotiData.client_secret})
    });
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { client_id, client_secret } = this.state;

    const data = {
      client:'DENTICON',
      client_id,
      client_secret
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
      this.props.storeZentiData(data)
    }
  }

  validate(data) {
    if (!(data.client_id || data.client_secret)) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { client_id, client_secret, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save client_id, client_secret information
            </p>
          ) : null}
        
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your client id *</p>
            <input
              type="text"
              name="client_id"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={client_id}
              onChange={this.onInputChange}
              autoComplete="false"
            />
            <p className="form-group__heading">Enter your client secret *</p>
            <input
              type="text"
              name="client_secret"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={client_secret}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};